/**
* Logo Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'logo-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.logo-scroller' ).each( function( key, val ) {
        const star1 = $( this ).find( '.star--1' )[0];
        const star2 = $( this ).find( '.star--2' )[0];
        const height = $( this ).find( '.inner-area' ).outerHeight();
        window.scrollRefreshPriority--;

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: $( this ).find( '.inner-area' )[0],
            pinSpacing: false,
            start: 'top top',
            end: '=+' + ( height * 2 ),
            refreshPriority: window.scrollRefreshPriority,
            scrub: 1,
            // markers: true,
          },
        } );

        window.scrollRefreshPriority--;
        const logoScroll = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: '=+' + ( height * 2 ),
            refreshPriority: window.scrollRefreshPriority,
            scrub: 1,
            onEnter: ( x, y, z ) => {
              const locations = [];
              $( this ).find( '.logo' ).each( function( logoKey, logo ) {
                $( logo ).addClass( 'is-loaded' );
                const containerWidth = $( logo ).closest( '.relative' ).outerWidth() - $( logo ).outerWidth();
                const containerHeight = $( logo ).closest( '.relative' ).outerHeight() - $( logo ).outerHeight();
                let top = 0;
                let left = 0;
                let bottom = 0;
                let right = 0;

                let overlapped = true;
                let i = 0;

                while ( overlapped ) {
                  top = ( Math.floor( Math.random() * ( containerHeight - 0 + 1 ) + 0 ) );
                  left = ( Math.floor( Math.random() * ( containerWidth - 0 + 1 ) + 0 ) );
                  bottom = top + $( logo ).outerHeight();
                  right = left + $( logo ).outerWidth();

                  overlapped = false;
                  locations.forEach( ( val, index ) => {
                    if (
                      ( bottom < val.top || top > val.bottom ) ||
                      ( left > val.right || right < val.left )
                    ) {
                      // overlapped = false;
                    } else {
                      overlapped = true;
                    }
                  } );
                  i++;
                  if ( i > 1000 || locations.length == 0 ) {
                    overlapped = false;
                  }
                }

                $( logo ).css( {
                  'top': top,
                  'left': left,
                } );

                locations.push( {
                  'top': top,
                  'left': left,
                  'bottom': bottom,
                  'right': right,
                } );
              } );
            },
            onLeaveBack: ( x, y, z ) => {
              $( this ).find( '.logo' ).removeClass( 'is-loaded' );
            },
          },
        } );

        window.scrollRefreshPriority--;
        const spinner = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top bottom',
            end: '=+' + ( height * 2 ),
            refreshPriority: window.scrollRefreshPriority,
            scrub: 1,
            // markers: true,
          },
        } );
        spinner.to( star1, {rotate: '300deg', ease: 'linear'}, 0 );
        spinner.to( star2, {rotate: '-360deg', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-scroller', COMPONENT );
} )( app );
